/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ViewerControllerIframe from '../controller/viewer-controller-iframe';

// TODO Přejmenovat na WebsiteViewerType, aby se nepletlo s web platformou.
/**
 * Typ média web aplikace.
 * Používá se pouze URL ze serveru bez podpory offline stavu.
 * @implements {ViewerType}
 */
class ViewerTypeWeb {
  /**
   * Vytvoří instanci.
   * @param {number} loadDelay
   * @param {HtmlIframePreflighter} preflighter
   * @param {ViewerSourceCreator} sourceCreator
   * @returns {ViewerTypeWeb} Nová instance.
   */
  constructor(loadDelay, preflighter, sourceCreator) {
    this.loadDelay = loadDelay;
    this.preflighter = preflighter;
    this.sourceCreator = sourceCreator;
  }

  /** @inheritdoc */
  createController() {
    return new ViewerControllerIframe(this.loadDelay, this.preflighter);
  }

  /** @inheritdoc */
  getCheckFile(medium) {
    // Weby nemají v detailu média nastavení "Kontrolovat aktuální verzi".
    return false;
  }

  /** @inheritdoc */
  getSourceCreator() {
    return this.sourceCreator;
  }

  /** @inheritdoc */
  getUrl(medium) {
    return new Promise((resolve) => resolve(medium.url ?? undefined));
  }

  /** @inheritdoc */
  isExtractable() {
    return false;
  }

  /** @inheritdoc */
  isOfflineable() {
    return false;
  }

  /** @inheritdoc */
  isPreloadable(medium) {
    // U webových stránek se moc nepočítá s tím, že by byly spuštěné na pozadí.
    // Dělá to problémy při naslouchání na události, např. události ovládání.
    // Byl řešen problém s autofocus, který se nechoval při preloadu správně.
    // Také nelze jednoduše vypnout zvuky, které mohou vznikat.
    // Proto je preload zakázaný.
    return false;
  }
}

export default ViewerTypeWeb;
